<app-page-header header="{{language.downloadfromunitheader}}" backgroundPath="assets/images/lead/default.png"
    [height]="197">
</app-page-header>

<section class="section-group" style="margin-top: 0;">
    <div class="container">


        <section *ngFor="let documentList of docList, index as i" class="section-download">
            <h2 class="topic-title">
                <span *ngIf="flag == 'th'" class="text">{{documentList.doc_type}}</span>
                <span *ngIf="flag == 'en'" class="text">{{documentList.doc_type_en}}</span>
            </h2>
            <div class="row">
                <ul class="list-download list-unstyled">
                    <ng-container *ngFor="let docDetail of documentList.docDetail; index as j; last as isLast;">
                        <ng-container *ngIf="flag == 'th'; else elsefilename">
                            <li *ngIf="docDetail.uri.trim()" class="col-md-6 col-sm-12">
                                <app-download-list-item countTopic="{{i+1}}" link="{{docDetail.uri.trim()}}"
                                    text="{{docDetail.filename}}">
                                </app-download-list-item>
                            </li>
                        </ng-container>
                        <ng-template #elsefilename>
                            <li *ngIf="docDetail.uri_en.trim()" class="col-md-6 col-sm-12">
                                <app-download-list-item countTopic="{{i+1}}" link="{{docDetail.uri_en.trim()}}"
                                    text="{{docDetail.filename_en}}">
                                </app-download-list-item>
                            </li>
                        </ng-template>
                    </ng-container>
                </ul>
            </div>
        </section>
    </div>
</section>